import React, { FC } from 'react';
import { TitleView } from './Title.view';

type Props = {
  title: string;
  isCart?: boolean;
  subTitle?: string;
};

export const Title: FC<Props> = (props) => {
  const { title, isCart, subTitle } = props;

  return <TitleView title={title} isCart={isCart} subTitle={subTitle} />;
};
